import { IEditWarehousePayload, IGetWarehouseList, IWarehouseCreate, IWarehouseDetails, IWarehouseListSearch } from "../../../types/master/warehouseInterface";
import { WarehouseActionTypes, WarehouseActions } from "../../actionTypes/master/warehouseActionTypes";

export const createWarehouse = (payload: IWarehouseCreate): WarehouseActionTypes => ({
  type: WarehouseActions.CREATE_WAREHOUSE,
  payload,
});

export const getWarehouseList = (payload: IWarehouseListSearch): WarehouseActionTypes => ({
  type: WarehouseActions.GET_WAREHOUSE_LIST,
  payload,
});

export const setWarehouseList = (warehouseList: Array<IGetWarehouseList>) : WarehouseActionTypes => ({
  type: WarehouseActions.SET_WAREHOUSE_LIST,
  payload: warehouseList
})

export const setWarehouseListPageCount = (payload:number): WarehouseActionTypes => ({
  type: WarehouseActions.SET_WAREHOUSE_LIST_PAGE_COUNT,
  payload
})

export const getWarehouseDataById = (id: string): WarehouseActionTypes => ({
  type: WarehouseActions.GET_WAREHOUSE_DATA_BY_ID,
  payload: id
})

export const setWarehouseDataById = (payload: IWarehouseDetails) => ({
  type: WarehouseActions.SET_WAREHOUSE_DATA_BY_ID,
  payload
})

export const editWarehouse = (payload: IEditWarehousePayload) => ({
  type: WarehouseActions.EDIT_WAREHOUSE_DATA_BY_ID,
  payload,
});

export const deleteWarehouse = (id: number): WarehouseActionTypes => ({
  type: WarehouseActions.DELETE_WAREHOUSE,
  payload: id,
});
